import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["proForm", "recyclerForm"]

  proChanged() {
    this.proFormTarget.requestSubmit()
  }

  recyclerChanged() {
    this.recyclerFormTarget.requestSubmit()
  }
}
